import { createSlice } from "@reduxjs/toolkit";

const initialQueueState = {
	tracks: [],
};

const queueSlice = createSlice({
	name: "queue",
	initialState: initialQueueState,
    reducers: {
        updateQueue(state, action) {
            const { tracks } = action.payload;
            state.tracks = tracks;
        }
	},
});

export const { updateQueue } = queueSlice.actions;
export default queueSlice.reducer;
